import { Angulartics2Settings } from './angulartics2-config';

export class Angulartics2Token {
  settings: Partial<Angulartics2Settings>;
}
